<script>
    // @ts-nocheck

    import {
        CheckMarkCircle,
        AlertCircle,
        HelpCircle,
        InformationCircle,
    } from '../Icons'
    import { onMount } from 'svelte'
    import { getCSSVar } from '$lib/utils'
    import Typography from './Typography.svelte'
    export let type
    export let style = ''
    export let alignIcon = 'center'
    let references = {
        error: ['alert-error', AlertCircle],
        critical: ['01', AlertCircle],
        warning: ['notification-warning', HelpCircle],
        success: ['validation-success', CheckMarkCircle],
        info: ['neutral', InformationCircle],
    }
    $: colors = Object.fromEntries(
        Object.entries(references).map(([k, v]) => {
            return [k, v[0]]
        })
    )
    $: icons = Object.fromEntries(
        Object.entries(references).map(([k, v]) => {
            return [k, v[1]]
        })
    )
    $: icon = icons[type]
    onMount((_) => {
        if (!(type in references)) {
            type = 'warning'
        }
    })
</script>

<div
    style={`background: var(--color-accent-${colors[type]}-bg); ${style}; align-items: ${alignIcon}`}
>
    <svelte:component
        this={icon}
        size={30}
        color={getCSSVar(`--color-accent-${colors[type]}`)}
    />
    <Typography
        style={'width: 100%; padding: 0; margin: 0; color: ' +
            getCSSVar(`--color-accent-${colors[type]}`)}
        type="label"><slot /></Typography
    >
</div>

<style>
    div {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        /* align-items: center; */
        gap: 16px;
        padding: 8px 24px;
        border-radius: 8px;
    }
</style>
